module.exports = __webpack_public_path__ + "img/draps.fb901a82.png";